import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BadgeCheck, FileDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { saveBlob } from "@/components/DocHistory";

export const SignedDocBanner = ({ chargeId }) => {
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    api.get(`/charges/${chargeId}/docs`).then((r) => setDocs(r.data.filter((d) => d.signed))).catch(() => setDocs([]));
  }, [chargeId]);
  const download = async (d) => {
    try { const r = await api.get(`/docs/files/${d.id}`, { responseType: "blob" }); saveBlob(r.data, d.filename); }
    catch (e) { toast.error("No se pudo descargar el documento firmado"); }
  };
  if (!docs.length) return null;
  return (
    <div className="space-y-2" data-testid="detail-signed-docs">
      {docs.map((d) => (
        <div key={d.id} className="flex flex-wrap items-center gap-3 rounded-xl border border-emerald-200 bg-emerald-50 p-4" data-testid={`detail-signed-doc-${d.id}`}>
          <BadgeCheck size={22} className="shrink-0 text-emerald-600" />
          <div className="min-w-[160px] flex-1">
            <p className="text-sm font-semibold text-emerald-900">Documento firmado por el huésped</p>
            <p className="text-xs text-emerald-800">{d.template_name} · {fmtDateTime(d.signed_at)}</p>
          </div>
          <Button size="sm" onClick={() => download(d)} className="bg-emerald-600 hover:bg-emerald-700" data-testid={`detail-signed-download-${d.id}`}>
            <FileDown size={15} className="mr-1.5" />Descargar PDF firmado
          </Button>
        </div>
      ))}
    </div>
  );
};
